module.exports = __webpack_public_path__ + "IGDC23-7cb5ed59.webp";